import React, { useState } from 'react';
import { Button } from '@abyss/web/ui/Button';
import { ModalService } from '@src/api/common/ModalService';

type DeleteButtonProps = {
  params: any;
  delete(): void;
  isDisabled?: boolean;
  title?: string;
  message?: string;
  style?: any;
};

const DeleteButton: React.FC<DeleteButtonProps> = ({
  params,
  delete: deleteItem,
  isDisabled,
  title = 'Delete',
  message = 'You are about to delete this record. Do you wish to continue?',
  style,
}: DeleteButtonProps) => {
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const { showModal, hideModal } = ModalService();

  const HandleDeleteClick = async () => {
    await showModal({
      key: 'delete-modal',
      title,
      message,
      handleConfirm: HandleDeleteConfirm,
      handleCancel: () => hideModal('delete-modal'),
      cancelText: 'Cancel',
      submitText: 'Confirm',
    });
  };

  const HandleDeleteConfirm = async () => {
    setButtonDisabled(true);
    await deleteItem();
    await hideModal('delete-modal');
  };

  return (
    <React.Fragment>
      {params.id > 0 ? (
        <Button
          variant="destructive"
          css={{ 'abyss-button-root': { marginTop: '20px' } }}
          onClick={HandleDeleteClick}
          isDisabled={buttonDisabled || isDisabled}
          style={style}
        >
          Delete
        </Button>
      ) : null}
    </React.Fragment>
  );
};

export { DeleteButton };
